export enum Keys {
  Role = "role",
  CurrGroupId = "CURRGROUPID",
  Language = "LANGUAGE",
  QuizPassing = "QuizPassing",
  AiQuizPassing = "AiQuizPassing",
  SortType = "SortType",
}
